import { useState } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import CanonicalTag from '../components/CanonicalTag';
import { Button } from '../components/ui/button';
import { Dialog, DialogContent, DialogTrigger } from '../components/ui/dialog';

// Portfolio images from Unsplash
const portfolioImages = [
  "https://images.unsplash.com/photo-1721322800607-8c38375eef04?w=800&h=600&fit=crop",
  "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=600&fit=crop",
  "https://images.unsplash.com/photo-1649972904349-6e44c42644a7?w=800&h=600&fit=crop"
];

const HowToUseADUAsBackyardLibraryOrReadingRoom = () => {
  const [isCalendlyOpen, setIsCalendlyOpen] = useState(false);

  const scrollToCTA = () => {
    const ctaSection = document.getElementById('cta-section');
    if (ctaSection) {
      ctaSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <CanonicalTag url="https://www.udaadu.com/how-to-use-adu-as-backyard-library-or-reading-room" />
      <Navigation />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="py-20 px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-4xl md:text-6xl font-bold mb-6">
                How to Use Your ADU as a Backyard Library or Reading Retreat
              </h1>
            </div>
            
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{ color: '#E4683B' }}>
                  Quiet. Cozy. Yours Alone.
                </h2>
                <p className="text-xl mb-8 text-white">
                  Imagine a private sanctuary filled with books, natural light, and zero distractions. Your ADU can become the personal library or reading space you've always wanted—just a few steps away.
                </p>
                <div className="flex flex-wrap gap-4">
                  <Button 
                    onClick={() => setIsCalendlyOpen(true)}
                    size="lg"
                    className="bg-primary hover:bg-primary/90"
                  >
                    📅 Book & Schedule
                  </Button>
                  <Button 
                    onClick={scrollToCTA}
                    variant="outline" 
                    size="lg"
                  >
                    💰 Get your price & ROI report
                  </Button>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <img 
                  src={portfolioImages[0]} 
                  alt="Peaceful reading space with natural light" 
                  className="w-full h-64 object-cover rounded-lg"
                />
                <img 
                  src={portfolioImages[1]} 
                  alt="Built-in bookshelves and cozy seating" 
                  className="w-full h-64 object-cover rounded-lg"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="py-20 px-4 bg-secondary/10">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <img 
                src={portfolioImages[2]} 
                alt="Cozy reading nook with large windows" 
                className="w-full h-96 object-cover rounded-lg"
              />
              <div>
                <h3 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                  Features
                </h3>
                <div className="space-y-4 text-white">
                  <div className="flex items-start gap-3">
                    <div className="w-2 h-2 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: '#E4683B' }}></div>
                    <p>Custom bookshelves and storage walls</p>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-2 h-2 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: '#E4683B' }}></div>
                    <p>Ambient lighting and reading nooks</p>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-2 h-2 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: '#E4683B' }}></div>
                    <p>Wood or quiet carpet flooring</p>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-2 h-2 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: '#E4683B' }}></div>
                    <p>Optional fireplace or skylights</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section id="cta-section" className="py-20 px-4">
          <div className="max-w-4xl mx-auto text-center">
            <p className="text-2xl mb-12 text-white">
              Rediscover your focus. Escape the noise. Make space for stories and stillness.
            </p>
            
            <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
              <Button 
                onClick={() => setIsCalendlyOpen(true)}
                size="lg"
                className="bg-primary hover:bg-primary/90"
              >
                📅 Book & Schedule
              </Button>
              <Button variant="outline" size="lg">
                📐 What fits my lot?
              </Button>
              <Button variant="outline" size="lg">
                💰 Get your price & ROI report
              </Button>
              <Button variant="outline" size="lg">
                🏡 Our Portfolio
              </Button>
              <Button variant="outline" size="lg">
                ❓ Our FAQ
              </Button>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      {/* Calendly Modal */}
      <Dialog open={isCalendlyOpen} onOpenChange={setIsCalendlyOpen}>
        <DialogContent className="max-w-4xl w-full h-[80vh]">
          <iframe
            src="https://calendly.com/udaadu"
            width="100%"
            height="100%"
            frameBorder="0"
            title="Schedule a consultation"
          ></iframe>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default HowToUseADUAsBackyardLibraryOrReadingRoom;